<template>
	<div class="contactus">
		<div class="img">
			<img :src="banner"/>
		</div>
		<!--路径-->
		<div class="container">
			<div class="path">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  	<el-breadcrumb-item>联系我们</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			
			<!--内容-->
			<div class="content clearfix">
				<div class="connect">
					<h3 style="">联系我们</h3>
					<p v-if="describe" style="margin-bottom:50px;">{{describe}}</p>
					<p>地址：{{address}}</p>
					<p>联系电话：{{phone}}</p>
					<p v-if="email">Email：{{email}}</p>
				</div>
				<div class="map">
					<baidu-map class="bm-view" :center="point" :zoom="15" :ak="ak">
						<bm-marker :position="point" :dragging="true" @click="infoWindowOpen">
					      	<bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">{{title}}</bm-info-window>
					      	<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
					    </bm-marker>
						</baidu-map>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {BaiduMap,BmMarker,BmInfoWindow,BmNavigation} from 'vue-baidu-map'
export default {
	name:'',
	components: {
    	BaiduMap,
    	BmMarker,
    	BmInfoWindow,
    	BmNavigation
  	},
	data(){
		return{
			banner:'',
			show: true,
			ak:'Q84C31uG00CN2srjoCCzlcxyGaC5YVGt',
			point:{
				lng: 116.404, 
				lat: 39.915
			},
			title:'',
			describe:'',
			address:'',
			email:'',
			phone:'',
		}
	},
	methods:{
		getSetting(){
			this.axios({
				method: 'get',
				url: this.GLOBAL.getInfoApi,
				data: {},
			})
			.then((res) => {
				this.point = res.data.data.geographic;
				this.title = res.data.data.siteName;
				this.address = res.data.data.address;
				this.phone = res.data.data.phone;
				this.email = res.data.data.email;
				this.describe = res.data.data.describe;
			})
			.catch((err) => {
				console.log(err)
			})
		},
		getBanner(){
			this.axios({
				method: 'get',
				url: this.GLOBAL.getBannerApi+'7',
				data: {},
			})
			.then((res) => {
				this.banner = res.data.data.banner7;
			})
			.catch((err) => {
				console.log(err)
			})
		},
		infoWindowClose () {
	      	this.show = false
	    },
	    infoWindowOpen () {
	      	this.show = true
	    }
	},
	created(){
		this.getBanner();
		this.getSetting();
	}

}
</script>

<style lang="less" scoped="scoped">
.contactus{
	.img{
		width:100%;
		height:350px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.path{
		margin-top: 20px;
		margin-bottom: 20px;
		i{
			font-size: 20px;
		}
		span{
			color: #00A0FF;
		}
		.news{
			width: 100px;
			height: 40px;
			/*border: 1px solid salmon;*/
			color: forestgreen;
			margin-left: 5px;
			margin-right: 5px;
		}
	}
	.content{
		margin-top: 50px;
		margin-bottom: 30px;
		.connect{
			width:50%;
			height:500px;
			float:left;
			padding:10px 50px;
			h3{
				margin: 10px 0 20px;
				font-size: 24px;
				font-weight: 500;
				color: #2e3b4e;
				
			}
			p{
				margin:10px 0px;
				color:#5f6a7d;
			}
		}
		.map{
			width:50%;
			height:500px;
			float:left
		}
	}
	.bm-view {
	  width: 100%;
	  height: 100%;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ContactUs/ContactUs.vue